export default class VodVideoService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/vodVideos', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/vodVideos/' + id, params)
	}

    resetLocalState(id){
        return this.apiService.callPost('me/vodVideos/'+ id +'/resetLocalState');
    }
}



// WEBPACK FOOTER //
// ./src/service/VodVideoService.js